<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page row-start">
        <div class="form-item-char30">
            <label class="label-caption">Opção de Relatório</label>
            <select v-model="opcaoSelecionada">
                <option v-for="opcao in lsOpcoes" :key="opcao.id" :value="opcao.id">{{ opcao.descricao }}</option>
            </select>
        </div>

        <div class="form-item">
            <SimSelect :ckAddTodos="true" v-model:idSelecionado="idSim" />
        </div>

        <button type="button" class="buttom-icon--printer" @click="openReport" />
        <button type="button" class="buttom-icon--close" @click="closePage" />
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';
import SimSelect from '@/components/selects/SimSelect.vue';

const emit = defineEmits(['close']);
const msgAlerta = ref(null);
const idSim = ref(0);
const isLoading = ref(false);

const lsOpcoes = ref([
    {id: 'estabelecimentos_cprod', descricao: 'Analítico'},
    {id: 'estabelecimentos_cprod_sint', descricao: 'Sintético'},
]);
const opcaoSelecionada = ref('estabelecimentos_cprod');

const closePage = () => {emit('close');}

const openReport = async() => {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            nmrelatorio: opcaoSelecionada.value,
            idep: globalStore.idep,
            idsim: idSim.value,
            idusuario: globalStore.idusuario
        };
        const response = await Api.genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}
</script>